export const BROKER_SHARE_SURVEY = 1;
export const SURVEY_STATUS_UPDATE = 2;
export const SURVEY_LISTING_COMMENT = 3;
export const COMMENT_DELETE = 4;
export const SURVEY_COMMENT = 5;
export const SURVEY_COMPARISON_COMMENT = 6;
export const SURVEY_BUILDING_COMMENT = 7;
export const COMMENT_EDIT = 8;
